import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { Box } from '@mui/material'
import { ROLES_SIXT, useAuth } from 'auth'
import { Navigate } from 'react-router-dom'

import PageTitle from 'components/atoms/PageTitle'
import PartnerDocumentsContent from 'components/organisms/PartnerDocuments'

export default function PartnerDocuments() {
  const { t } = useTranslation()

  const { hasOneOfRoles } = useAuth()

  const admin = useMemo(() => hasOneOfRoles(ROLES_SIXT), [hasOneOfRoles])

  if (admin) {
    return <Navigate replace to="/agenda" />
  }

  return (
    <Box className="content-container">
      <PageTitle label={t('partnerDocuments.title')} />
      <PartnerDocumentsContent />
    </Box>
  )
}
